const PAYMENT = {
  DUITKU: "1",
  MIDTRANS: "6",
};
export { PAYMENT };
